export class QueryStringFormBlock {
    readonly QueryStringAttribute = 'data-query-string-value';
    constructor() {
        document.addEventListener("replaceState", (e) => {
            this.bindValues();
        });

        window.addEventListener("popstate", (e) => {
            this.bindValues();
        });
    }

    bindValues = () => {
        //Update hidden fields in epi forms
        const queryInputs = document.querySelectorAll(`[${this.QueryStringAttribute}]`);
        [].forEach.call(queryInputs, (input) => {
            const queryStringName = input.getAttribute(`${this.QueryStringAttribute}`);
            if (queryStringName) {
                input.value = this.getParameterByName(queryStringName);
            }
            else {
                const queryStringIndictorIndex = window.location.href.indexOf('?');
                if (queryStringIndictorIndex > -1)
                    input.value = window.location.href.substring(queryStringIndictorIndex);
            }
        });
    }

    getParameterByName = (name, url = null) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}